import * as actionTypes from '../../Action/actionTypes';

const initialState = {
  userGroupDetails: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_USER_GROUP_DETAILS:
      console.log("UUG: ", action.value)
      return {
        ...state,
        userGroupDetails: action.value
      };
    default:
      return state;
  }
};

export default reducer;
